<div class="mainCntnr">
  <div class="contentCntnr">
    <div class="leftSideCntnr">
      <img alt="Logo Image" src="assets/SAI-retail-cpg-logo-horizontal-full-color.svg" />
    </div>
    <div class="rightSideCntnr">
      <div class="listCntnr">
        <div *ngFor="let tenant of configObj.tenantList" class="listItem" (click)="navigateToDomain(tenant)">
          <span>{{tenant['TenantName']}}</span>
        </div>

        <!--<div class="listItem">
          <a>First Env</a>
        </div>
        <div class="listItem">
          <a>Second Env</a>
        </div>-->
      </div>
    </div>
  </div>
</div>
